export default {
  loaded: false,
  mode: 'loading', // Can be intro, tutorial, playing, paused or gameover
  showOverlay: false,
  tutorialDone: false,

  score: 0,
  level: 1,
  fuel: 100,
  skin: 'YELLOW',
  playerDistance: 0,

  userData: {
    score: 0,
    userName: 'userName',
    scoreRange: [],
    data: {
      blueberries: 0,
      strawberries: 0,
      mt: 0,
    },
  },
};
